import React from 'react';
import classNames from 'classnames';

export enum ButtonColor {
  BLUE = 'blue',
  LIGHTBLUE = 'lightBlue',
  BORDER_BLUE = 'borderBlue'
}

export enum ButtonType {
  SUBMIT = 'submit',
  BUTTON = 'button'
}

export enum ButtonModifiers {
  ROUND = 'round',
  SELECT = 'select'
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

export interface CustomButtonProps {
  title: string | React.ReactNode;
  active?: boolean;
  color?: ButtonColor;
  disabled?: boolean;
  ellipsis?: boolean;
  fullWidth?: boolean;
  type?: ButtonType;
  modifiers?: ButtonModifiers;
  size?: ButtonSize;
  noWrap?: boolean;
  onClick?(): void;
}

import './CustomButton.scss';

export const CustomButton = ({
  title,
  active,
  color = ButtonColor.BLUE,
  onClick,
  disabled,
  ellipsis = false,
  fullWidth = false,
  modifiers,
  size,
  type = ButtonType.BUTTON,
  noWrap = false
}: CustomButtonProps) => {

  // Define the CSS class names for the button based on its color
  const buttonClasses = classNames('custom-button', {
    'custom-button--blue': color === ButtonColor.BLUE,
    'custom-button--lightBlue': color === ButtonColor.LIGHTBLUE,
    'custom-button--borderBlue': color === ButtonColor.BORDER_BLUE,
    'custom-button--round': modifiers === ButtonModifiers.ROUND,
    'custom-button--select': modifiers === ButtonModifiers.SELECT,
    'custom-button--small': size === ButtonSize.SMALL,
    'custom-button--medium': size === ButtonSize.MEDIUM,
    'custom-button--no-wrap': noWrap,
    'custom-button--ellipsis': ellipsis,
    'custom-button--full-width': fullWidth,
    active
  });

  return (
    <button
      styleName={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      <span styleName={classNames('custom-button__title', {
        'custom-button__title--ellipsis': ellipsis
      })}>
        {title}
      </span>
      {modifiers === ButtonModifiers.SELECT &&
        <span styleName="custom-button__icon" className="dashicon dashicon-checkmark"/>
      }
    </button>
  );
};
